export default{

  name:'constants',
  BASE_URL: window.location.hostname === 'localhost'?'http://localhost:5000/':"https://aibe.mall91.com/"


}



// WEBPACK FOOTER //
// ./src/constant.js